import {
  computed,
  createSitePathResolver,
  useHead,
  useRoute,
  useSeoMeta,
  useServerHead,
  useSiteConfig
} from "#imports";
export function applyDefaults() {
  const siteConfig = useSiteConfig();
  const route = useRoute();
  const resolveUrl = createSitePathResolver({ withBase: true, absolute: true });
  const canonicalUrl = computed(() => resolveUrl(route.path || "/").value || route.path);
  const minimalPriority = {
    // give nuxt.config values higher priority
    tagPriority: 101
  };
  useHead({
    link: [{ rel: "canonical", href: () => canonicalUrl.value }]
  });
  const locale = siteConfig.currentLocale || siteConfig.defaultLocale;
  if (locale) {
    useServerHead({
      htmlAttrs: { lang: locale }
    });
  }
  useHead({
    templateParams: { site: siteConfig, siteName: siteConfig.name || "" },
    titleTemplate: "%s %separator %siteName"
  }, minimalPriority);
  const seoMeta = {
    ogType: "website",
    ogUrl: () => canonicalUrl.value,
    ogLocale: locale,
    ogSiteName: siteConfig.name
  };
  if (siteConfig.description)
    seoMeta.description = siteConfig.description;
  if (siteConfig.twitter) {
    const id = siteConfig.twitter.startsWith("@") ? siteConfig.twitter : `@${siteConfig.twitter}`;
    seoMeta.twitterCreator = id;
    seoMeta.twitterSite = id;
  }
  useSeoMeta(seoMeta, minimalPriority);
}
